import $ from 'jquery';

$(() => {
	// remove loading
	window.setTimeout(() => {
		$('#content-wrapper').removeClass('loading-overlay').addClass('content-loaded');
		// $('[autofocus]').trigger('focus'); // Already handled by mpro.forms.js
	}, 400);

	// loader - Preloader
	$('#status').fadeOut();
	$('#preloader').delay(200).fadeOut();
});